import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import styled from "styled-components";
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import SchoolCategoryModal from "../../components/modals/PicklistModals/schoolCategoryModal";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import SeriesCategoryModal from "../../components/modals/seriesCategoryModal";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const TableContainer = styled.div`
  height: calc(
    100vh - ${isMobile ? "56px - 20px - 82.23px" : "100px - 20px - 43.77px"}
  );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: calc(100% );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

export default function SeriesMaster() {

  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [visitModal, setVisitModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)

  useEffect(() => {
    getSeriesData();
  }, []);

  const getSeriesData = async () => {
    try {
      setLoading(true);
      // let results1 = await window.Platform.database.testApi();

      let results = await window.Platform.database.getSeriesCategory();
      console.log("results", results);
      // if(auth?.user?.role === ROLES.ADMIN){
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

      setAccessChanges(jsonArrayWithId);
      // }
      // setVisibleEmployees(results);
      // setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const handleDelete = async (data) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this series?");

    if (!isConfirmed) {
      return;
    }

    try {
      setLoading(true);
      let results = await window.Platform.database.deleteSeriesCategory({ id: data });
      setLoading(false);

      window.NotificationUtils.showSuccess("Series deleted successfully!");
      getSeriesData();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const goBack = () => {
    navigate(-1);
  }

  const getSeriesColumns = () => {
    let result = [
      {
        field: "seriesName",
        headerName: "Name",
        width: 180,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.seriesName || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.seriesName.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "return",
        headerName: "Return percent",
        width: 130,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.return || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.return || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "discountType",
        headerName: "Discount Type",
        width: 120,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.discountType || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.discountType || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "flatDiscount",
        headerName: "Flat Discount",
        width: 130,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.flatDiscount || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.flatDiscount || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "minDiscount",
        headerName: "Min Discount",
        width: 130,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.minDiscount || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.minDiscount == 0 ? 0 : params.row.minDiscount || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "maxDiscount",
        headerName: "Max Discount",
        width: 130,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.maxDiscount || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.maxDiscount || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "incentive",
        headerName: "Incentive",
        width: 90,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.incentiveApplied == 0 ? "No" : "Yes");
        },
        renderCell: (params) => {
          let name = params.row?.incentiveApplied == 0 ? "No" : "Yes";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      (userData?.role === "super admin" || userData?.master === 1) && {
        field: "isSpecimen!2",
        headerName: "IS Specimen",
        width:  140,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.specimen == "true" ? "True" : params.row?.specimen == "false" ?  "False" : "N/A" || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.specimen == "true" ? "True" : params.row?.specimen == "false" ?  "False" : "N/A" || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        hide: true,
        minWidth: 140,
        renderCell: (params) => {
          return (
            <>
              <Tooltip title={"Update"}>
                <IconButton onClick={() => handleEdit(params.row)}>
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Delete"}>
                <IconButton onClick={() => handleDelete(params.row.seriesTableId)}>
                  <DeleteIcon sx={{ color: "Red", fontSize: "22px", fontWeight: "400" }} />
                </IconButton>
              </Tooltip>
            </>
          )
        },
      }
    ];
    return result;
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton />
        <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  }

  const renderContent = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges || []}
            columns={getSeriesColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            rowHeight={60}
            disableSelectionOnClick
            disableRowSelectionOnClick
            autoPageSize
            components={{
              Toolbar: CustomToolbar,
            }}
            pageSizeOptions={[10]}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const addVisit = () => {
    setVisitModal(true);
  }

  const handleEdit = (data) => {
    setEditModal(true);
    setDataModal(data);
  }

  return (
    <>
      {isMobile && (
        <Drawer />
      )}
      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <div>
            <Button variant="outlined" onClick={goBack} sx={{ mb: 2 }}>
              <ArrowBackIcon sx={{ marginRight: "2px" }} /> Back
            </Button>
          </div>

          <Stack direction={"row"} spacing={2} >
            <Button variant="contained" color="primary"
              onClick={() => addVisit()} sx={{ mr: 1, borderRadius: '10px' }}>
              <Add sx={{ mr: 1 }} />
              Add New
            </Button>
          </Stack>

        </HeaderContainer>
        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>
      {
        visitModal &&
        <SeriesCategoryModal
          onClose={() => setVisitModal(false)}
          loading={loading}
          fetchData={() => getSeriesData()}
          status={true}
        />
      }
      {
        editModal &&
        <SeriesCategoryModal
          onClose={() => setEditModal(false)}
          loading={loading}
          fetchData={() => getSeriesData()}
          status={false}
          propData={dataModal}
        />
      }

    </>
  );
}
